module.exports = __webpack_public_path__ + "static/media/arrow-down.9b93a8e9.svg";